import AppDispatcher from 'AppDispatcher'
import {Actions} from './Constants'

export default {
   new: organization => {
      AppDispatcher.dispatch({
         actionType: Actions.new,
         key:        organization.nid,
         organization
      })
   },

   update: (key, patch) => {
      AppDispatcher.dispatch({
         actionType:   Actions.update,
         key,
         organization: patch
      })
   },

   list: organizations => {
      AppDispatcher.dispatch({
         actionType: Actions.list,
         organizations
      })
   },

   change: (key, organization) => {
      AppDispatcher.dispatch({
         actionType: Actions.change,
         key,
         organization
      })
   }
}



// WEBPACK FOOTER //
// lib/api/organization/Actions.js